module.exports = __webpack_public_path__ + "static/media/Sy_for_Dummies3.3dbc0b50.jpeg";